import React from 'react';
import { MessageCircle, Folder, Lightbulb, BookOpen } from 'lucide-react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar';

const menuItems = [
  { id: 'assistant', label: 'L&R Chatbot-Assistent', icon: MessageCircle, path: '/' },
  { id: 'documents', label: 'Datei-Verwaltung', icon: Folder, path: '/documents' },
  { id: 'few-shot', label: 'Beispiel-Datenbank', icon: Lightbulb, path: '/few-shot' },
  { id: 'anleitung', label: 'Schulungsunterlagen', icon: BookOpen, path: '/anleitung' },
];

export function AppSidebar() {
  const { state } = useSidebar();
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path: string) => currentPath === path;
  const isCollapsed = state === 'collapsed';

  return (
    <Sidebar
      collapsible="icon"
      className="border-r border-sidebar-border"
    >
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Navigation</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {menuItems.map((item) => (
                <SidebarMenuItem key={item.id}>
                  <SidebarMenuButton
                    asChild
                    isActive={isActive(item.path)}
                  >
                    <NavLink
                      to={item.path}
                      className="flex items-center gap-2 w-full"
                    >
                      <item.icon className="w-4 h-4 flex-shrink-0" />
                      <span className={`${isCollapsed ? 'sr-only' : ''} transition-all duration-200`}>
                        {item.label}
                      </span>
                    </NavLink>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  );
}